import type { RouteRecordRaw } from 'vue-router'
import HomeFr from '../views/HomeFr.vue'
import HomeEn from '../views/HomeEn.vue'

export const routes: RouteRecordRaw[] = [
  { path: '/', name: 'HomeFr', component: HomeFr },
  { path: '/fr', name: 'HomeFrAlt', component: HomeFr },
  { path: '/en', name: 'HomeEn', component: HomeEn },
]

